<template>
  <div class="navigation-wrapper">
    <v-navigation-drawer
      :value="drawer"
      v-model="drawer"
      :mini-variant.sync="Mini"
      disable-resize-watcher
      app
      :width="drawerWidth"
      class="custom-nav-drawer"
    >
      <!-- User Profile Header -->
      <div class="user-profile-card">
        <v-img
          src="/images/background/user-img-background.jpg"
          class="user-profile-bg"
          :class="{ 'user-profile-bg--mini': Mini }"
        >
          <div class="user-profile-overlay">
            <div class="user-avatar-container" @click="navigation()">
              <v-avatar size="48" class="user-avatar-shadow">
                <v-img src="/images/background/user.png" alt="Usuario"></v-img>
              </v-avatar>
            </div>
            <div v-if="!Mini" class="user-info-text">
              <div class="user-info-item user-info-item--name">
                <v-icon small class="user-info-icon">mdi-account</v-icon>
                <span class="user-info-label">{{ name || "Usuario" }}</span>
              </div>
              <div class="user-info-item user-info-item--email">
                <v-icon small class="user-info-icon">mdi-email-outline</v-icon>
                <span class="user-info-label">{{
                  email || "usuario@tiresoft.com"
                }}</span>
              </div>
              <div v-if="userRole" class="user-info-item user-info-item--role">
                <v-icon small class="user-info-icon"
                  >mdi-shield-account-outline</v-icon
                >
                <span class="user-info-label">{{ userRole }}</span>
              </div>
            </div>
          </div>
        </v-img>
      </div>

      <v-divider class="nav-divider"></v-divider>

      <!-- Navigation List Items -->
      <v-list class="nav-menu-list pa-2" dense>
        <div
          v-for="(item_menu, index_menu) in items"
          :key="index_menu"
          class="nav-menu-block mb-1"
        >
          <!-- Menú con Submenús (Nivel 1 con hijos) -->
          <v-list-group
            v-if="
              item_menu.menu_submenu &&
              Object.keys(item_menu.menu_submenu).length > 0
            "
            :prepend-icon="item_menu.icon"
            @click="desplegarMenu(item_menu.id)"
            :value="item_menu.desplegar"
            color="indigo"
            class="custom-list-group"
          >
            <template v-slot:activator>
              <v-list-item-title class="nav-item-title nav-item-title--parent">
                {{ item_menu.menu }}
              </v-list-item-title>
            </template>

            <v-list-item-group
              v-model="item_menu.selectedItem"
              :mandatory="false"
              class="nav-submenu-wrapper pl-2"
            >
              <div
                v-for="(item_submenu, index_submenu) in item_menu.menu_submenu"
                :key="index_submenu"
              >
                <!-- Submenú Nivel 2 (Ruta directa sin más hijos) -->
                <v-list-item
                  v-if="
                    Object.keys(item_submenu.menu_submenu || {}).length === 0
                  "
                  @click="
                    insertarRuta(item_submenu.id, item_submenu.path, 'nivel2')
                  "
                  :class="{
                    'v-item--active v-list-item--active custom-active-item':
                      item_submenu.id == $route.meta.id ||
                      item_submenu.path == $route.path,
                  }"
                  class="custom-list-item custom-list-item--sub"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="slate">mdi-circle-small</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="nav-item-title nav-item-title--child text-wrap"
                    >
                      {{ item_submenu.description }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- Submenú Nivel 2 que tiene hijos (Nivel 3) -->
                <v-list-group
                  v-else
                  no-action
                  sub-group
                  color="indigo"
                  :value="item_submenu.desplegar"
                  class="custom-nested-group"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title
                        class="nav-item-title nav-item-title--nested text-wrap"
                      >
                        {{ item_submenu.description }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item-group
                    v-model="item_submenu.selectedItemSub"
                    class="pl-2"
                  >
                    <v-list-item
                      v-for="(item, index) in item_submenu.menu_submenu"
                      :key="index"
                      @click="
                        insertarRuta(
                          item.id || item_submenu.id,
                          item.path,
                          'nivel3',
                        )
                      "
                      :class="{
                        'v-item--active v-list-item--active custom-active-item':
                          item.id == $route.meta.id || item.path == $route.path,
                      }"
                      class="custom-list-item custom-list-item--deep"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon small color="slate">mdi-minus</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="nav-item-title nav-item-title--deep text-wrap"
                        >
                          {{ item.description }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list-group>
              </div>
            </v-list-item-group>
          </v-list-group>

          <!-- Menú sin Submenús (Ruta directa en Nivel 1) -->
          <v-list-item
            v-else
            @click="insertarRuta(item_menu.id, item_menu.path)"
            :class="{
              'v-item--active v-list-item--active custom-active-item':
                item_menu.id == $route.meta.id || item_menu.path == $route.path,
            }"
            class="custom-list-item custom-list-item--root"
          >
            <v-list-item-icon class="mr-3">
              <v-icon class="nav-icon">{{ item_menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="nav-item-title nav-item-title--root text-wrap"
              >
                {{ item_menu.menu }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>

      <!-- Drawer Footer -->
      <template v-slot:append>
        <div class="nav-footer" v-if="!Mini">
          <p class="version-label">
            Tiresoft.pe versión {{ appVersion }} ({{ appDate }})
          </p>
        </div>
      </template>
    </v-navigation-drawer>

    <Bar
      :drawer="drawer"
      @drawer="drawer = $event"
      @revertirDespliegue="revertirDespliegue"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Bar from "@/components/layout/Bar.vue";
import global from "@/global";

export default {
  name: "NavigationDrawer",
  components: {
    Bar,
  },
  data() {
    return {
      name: localStorage.getItem("name"),
      email: localStorage.getItem("email"),
      role: localStorage.getItem("role") || localStorage.getItem("rol"),
      drawer: true,
      items: [],
      drawerWidth: 290,
      appVersion: global.app_version,
      appDate: global.app_build_date,
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters("navigation", ["Mini", "Menu"]),
    userRole() {
      if (!this.role) return "";
      const roleMap = {
        1: "Administrador",
        2: "Supervisor",
        3: "Operador",
        4: "Usuario",
        5: "Cliente",
      };
      return roleMap[this.role] || this.role;
    },
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.restaurarEstadoMenu();
      });
    },
  },
  methods: {
    ...mapActions("navigation", ["Minimizar", "loadRoutes"]),
    ...mapActions("cliente", ["registrarSalidaDeCliente"]),

    insertarRuta: async function (id, path, nivel) {
      this.navigation();

      if (this.$route.path != path) {
        if (path == "/salirCliente") {
          await this.registrarSalidaDeCliente();
          sessionStorage.removeItem("id_cliente_seleccionado");
          sessionStorage.removeItem("idcliente");
          sessionStorage.removeItem("idclient");
          localStorage.removeItem("idcliente");
          localStorage.removeItem("id_cliente_seleccionado");
          localStorage.removeItem("idclient");
          sessionStorage.removeItem("nav_menu_id");
          sessionStorage.removeItem("nav_submenu_id");
          sessionStorage.removeItem("nav_nivel");
          this.$router.go({
            path: path,
          });
        } else {
          this.$router.push({
            path: path,
          });
        }

        this.guardarEstadoMenuEnCache(id, nivel);

        Object.keys(this.items).forEach((key) => {
          const element = this.items[key];

          if (element.id != id) {
            this.$set(element, "selectedItem", null);
          }

          if (nivel == "nivel2") {
            const submenus = Array.isArray(element.menu_submenu)
              ? element.menu_submenu
              : Object.values(element.menu_submenu || {});
            submenus.forEach((element2) => {
              this.$set(element2, "selectedItemSub", null);
            });
          }
        });
      }
      this.$forceUpdate();
    },
    desplegarMenu: function (id) {
      Object.keys(this.items).forEach((key) => {
        const item = this.items[key];
        if (item.id == id) {
          const nextVal = !item.desplegar;
          this.$set(item, "desplegar", nextVal);
          if (nextVal) {
            sessionStorage.setItem("nav_menu_id", String(id));
          } else {
            sessionStorage.removeItem("nav_menu_id");
          }
        } else {
          this.$set(item, "desplegar", false);
        }
      });
      this.$forceUpdate();
    },
    revertirDespliegue: function () {
      Object.keys(this.items).forEach((key) => {
        this.$set(this.items[key], "desplegar", false);
        this.$set(this.items[key], "selectedItem", null);
      });
      sessionStorage.removeItem("nav_menu_id");
      sessionStorage.removeItem("nav_submenu_id");
      sessionStorage.removeItem("nav_nivel");
      this.$forceUpdate();
    },
    guardarEstadoMenuEnCache: function (submenuId, nivel) {
      if (!this.items) return;

      const keys = Object.keys(this.items);
      for (let i = 0; i < keys.length; i++) {
        const item_menu = this.items[keys[i]];
        if (!item_menu) continue;

        const submenus = Array.isArray(item_menu.menu_submenu)
          ? item_menu.menu_submenu
          : Object.values(item_menu.menu_submenu || {});

        if (submenus.length === 0 && item_menu.id == submenuId) {
          sessionStorage.setItem("nav_menu_id", String(item_menu.id));
          sessionStorage.removeItem("nav_submenu_id");
          sessionStorage.setItem("nav_nivel", "nivel1");
          return;
        }

        for (let j = 0; j < submenus.length; j++) {
          const item_submenu = submenus[j];
          if (!item_submenu) continue;

          if (item_submenu.id == submenuId) {
            sessionStorage.setItem("nav_menu_id", String(item_menu.id));
            sessionStorage.setItem("nav_submenu_id", String(submenuId));
            sessionStorage.setItem("nav_nivel", nivel || "nivel2");
            return;
          }

          const subSubmenus = Array.isArray(item_submenu.menu_submenu)
            ? item_submenu.menu_submenu
            : Object.values(item_submenu.menu_submenu || {});

          for (let k = 0; k < subSubmenus.length; k++) {
            if (subSubmenus[k] && subSubmenus[k].id == submenuId) {
              sessionStorage.setItem("nav_menu_id", String(item_menu.id));
              sessionStorage.setItem("nav_submenu_id", String(submenuId));
              sessionStorage.setItem("nav_nivel", nivel || "nivel3");
              return;
            }
          }
        }
      }
    },
    restaurarEstadoMenu: function () {
      if (!this.items || Object.keys(this.items).length === 0) return;

      const savedMenuId = sessionStorage.getItem("nav_menu_id");
      const currentRouteId = this.$route.meta ? this.$route.meta.id : null;
      const currentPath = this.$route.path;

      const keys = Object.keys(this.items);

      for (let i = 0; i < keys.length; i++) {
        const item_menu = this.items[keys[i]];
        if (!item_menu) continue;

        const submenus = Array.isArray(item_menu.menu_submenu)
          ? item_menu.menu_submenu
          : Object.values(item_menu.menu_submenu || {});

        if (submenus.length === 0) {
          if (
            (currentRouteId && item_menu.id == currentRouteId) ||
            (currentPath && item_menu.path == currentPath)
          ) {
            this.$set(item_menu, "desplegar", false);
            sessionStorage.setItem("nav_menu_id", String(item_menu.id));
            sessionStorage.removeItem("nav_submenu_id");
          } else {
            this.$set(item_menu, "desplegar", false);
          }
          continue;
        }

        let isChildActive = false;
        let activeSubmenuIndex = null;
        let activeSubSubmenuIndex = null;
        let activeSubmenuObj = null;

        for (let j = 0; j < submenus.length; j++) {
          const item_submenu = submenus[j];
          if (!item_submenu) continue;

          const subSubmenus = Array.isArray(item_submenu.menu_submenu)
            ? item_submenu.menu_submenu
            : Object.values(item_submenu.menu_submenu || {});

          const matchesNivel2 =
            (currentRouteId && item_submenu.id == currentRouteId) ||
            (currentPath && item_submenu.path == currentPath);

          if (subSubmenus.length === 0 && matchesNivel2) {
            isChildActive = true;
            activeSubmenuIndex = j;
            break;
          }

          if (subSubmenus.length > 0) {
            for (let k = 0; k < subSubmenus.length; k++) {
              const subItem = subSubmenus[k];
              if (!subItem) continue;
              if (
                (currentRouteId && subItem.id == currentRouteId) ||
                (currentPath && subItem.path == currentPath)
              ) {
                isChildActive = true;
                activeSubmenuIndex = j;
                activeSubSubmenuIndex = k;
                activeSubmenuObj = item_submenu;
                this.$set(item_submenu, "desplegar", true);
                break;
              }
            }
            if (isChildActive) break;
          }
        }

        if (isChildActive || (savedMenuId && item_menu.id == savedMenuId)) {
          this.$set(item_menu, "desplegar", true);
          if (activeSubmenuIndex !== null) {
            this.$set(item_menu, "selectedItem", activeSubmenuIndex);
          }
          if (activeSubSubmenuIndex !== null && activeSubmenuObj) {
            this.$set(
              activeSubmenuObj,
              "selectedItemSub",
              activeSubSubmenuIndex,
            );
            this.$set(activeSubmenuObj, "desplegar", true);
          }
          sessionStorage.setItem("nav_menu_id", String(item_menu.id));
        } else {
          this.$set(item_menu, "desplegar", false);
          this.$set(item_menu, "selectedItem", null);
        }
      }

      this.$forceUpdate();
    },
    navigation() {
      if (this.Mini) {
        this.Minimizar(!this.Mini);
      }
    },
  },
  mounted: async function () {
    await this.loadRoutes(1);
    this.items = this.Menu;

    this.$nextTick(() => {
      this.restaurarEstadoMenu();
    });
  },
};
</script>

<style scoped>
/* =========================================================
   UI/UX ENHANCEMENTS - NAVIGATION DRAWER
   Normalized Spacings, WCAG Touch Targets (44px+), 
   Typography Scale >= 14px, Smooth Micro-transitions
   ========================================================= */

.custom-nav-drawer {
  background: #ffffff !important;
  border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 2px 0 12px rgba(15, 23, 42, 0.04) !important;
  font-family: inherit;
}

/* User Profile Header */
.user-profile-card {
  position: relative;
  overflow: hidden;
}

.user-profile-bg {
  height: 180px !important;
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.user-profile-bg--mini {
  height: 80px !important;
}

.user-profile-overlay {
  height: 100%;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.45) 0%,
    rgba(15, 23, 42, 0.88) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
}

.user-avatar-container {
  cursor: pointer;
  margin-bottom: 8px;
  display: inline-block;
  transition: transform 0.2s ease;
}

/* .user-avatar-container:hover {
  transform: scale(1.05);
} */

.user-avatar-shadow {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  border: 2px solid rgba(255, 255, 255, 0.85);
}

.user-info-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.user-info-item {
  display: flex;
  align-items: center;
  gap: 7px;
  line-height: 1.25;
  min-width: 0;
}

.user-info-icon {
  font-size: 15px !important;
  flex-shrink: 0;
}

.user-info-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info-item--name .user-info-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

.user-info-item--name .user-info-icon {
  color: #e2e8f0 !important;
}

.user-info-item--email .user-info-label {
  color: #cbd5e1;
  font-size: 12.5px;
  font-weight: 400;
}

.user-info-item--email .user-info-icon {
  color: #94a3b8 !important;
}

.user-info-item--role .user-info-label {
  color: #c7d2fe;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.user-info-item--role .user-info-icon {
  color: #a5b4fc !important;
}

.nav-divider {
  border-color: rgba(0, 0, 0, 0.06) !important;
}

/* Menu Items & Groups */
.nav-menu-list {
  padding-top: 12px !important;
  padding-bottom: 16px !important;
}

.custom-list-item,
::v-deep .v-list-group__header {
  min-height: 44px !important; /* WCAG standard touch target */
  border-radius: 8px !important;
  margin-bottom: 4px !important;
  padding: 0 12px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.custom-list-item:hover,
::v-deep .v-list-group__header:hover {
  background-color: rgba(99, 102, 241, 0.06) !important;
  transform: translateX(3px);
}

/* Typography Hierarchy (>= 14px everywhere) */
.nav-item-title {
  font-size: 14.5px !important;
  letter-spacing: 0.01em;
  color: #334155;
}

.nav-item-title--root,
.nav-item-title--parent {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #1e293b;
}

.nav-item-title--child {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #475569;
}

.nav-item-title--nested {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #334155;
}

.nav-item-title--deep {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #475569;
}

/* Active State Styles */
.custom-active-item,
::v-deep .v-list-item--active:not(.v-list-group__header) {
  background: linear-gradient(
    90deg,
    rgba(79, 70, 229, 0.12) 0%,
    rgba(79, 70, 229, 0.03) 100%
  ) !important;
  color: #4338ca !important;
  font-weight: 600 !important;
  border-left: 4px solid #4f46e5 !important;
  box-shadow: 0 1px 3px rgba(79, 70, 229, 0.1) !important;
}

.custom-active-item .nav-item-title,
::v-deep .v-list-item--active .nav-item-title {
  color: #4338ca !important;
  font-weight: 600 !important;
}

/* Submenu container indentation */
.nav-submenu-wrapper {
  border-left: 1px dashed rgba(203, 213, 225, 0.8);
  margin-left: 20px;
  margin-top: 4px;
  margin-bottom: 6px;
}

/* Footer Section */
.nav-footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #f8fafc;
  text-align: center;
}

.version-label {
  color: #94a3b8;
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 500;
  line-height: 1.3;
}

/* Custom Scrollbar */
::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}
</style>
